// DaftarTab.js — Tab Ajukan Zona KHAS
import React, { useState, useRef } from 'react'
import { PROVINSI, BASIS, KRITERIA, TIPE_KAWASAN, STATUS_PENGAJUAN } from './khasConstants'
import { pengajuanApi } from './khasApi'

const FORM0 = {
  nama:'', provinsi:'', kota:'', alamat:'',
  basis:'', tipe:'a1', pic:'', telp:'', email:'',
  instansi:'', alamat_instansi:'',
  k0:false, k1:false, k2:false, k3:false, k4:false, k5:false,
  catatan:''
}

/* ── Success Modal ─────────────────────────────────────────── */
function SuccessModal({ rec, onClose, onGoTab }) {
  return (
    <div className="khas-success-overlay">
      <div className="khas-success-box">
        <div className="khas-success-header">
          <button className="khas-success-close" onClick={onClose}>{String.fromCharCode(215)}</button>
          <div className="khas-success-icon">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="20 6 9 17 4 12"/>
            </svg>
          </div>
          <h2>Pengajuan Berhasil Dikirim</h2>
          <p>Meninjau kelengkapan berkas pengajuan Anda</p>
        </div>
        <div className="khas-success-body">
          <p style={{ fontSize:13.5, color:'var(--khas-muted)', margin:'0 0 18px' }}>
            Pengajuan Anda telah diterima dan akan segera diverifikasi.
          </p>
          <div className="khas-info-grid">
            {[
              ['Kawasan', rec.nama],
              ['Lokasi',  rec.kota + ', ' + rec.provinsi],
              ['Tipe',    TIPE_KAWASAN.find(t => t.value === rec.tipe)?.label || rec.tipe],
              ['Status',  STATUS_PENGAJUAN.PROSES],
            ].map(([label, val]) => (
              <div key={label} className="khas-info-card">
                <div className="khas-info-card-label">{label}</div>
                <div className="khas-info-card-value">{val}</div>
              </div>
            ))}
          </div>
          <div className="khas-steps-section">
            <p className="khas-steps-title">Langkah selanjutnya</p>
            {[
              'Verifikasi kelengkapan berkas pengajuan Anda',
              'Pantau status di tab Riwayat',
              'Setelah disetujui, lanjutkan ke tab Penetapan',
            ].map((step, i) => (
              <div key={i} className="khas-step-item">
                <span className="khas-step-num">{i+1}.</span>
                <span>{step}</span>
              </div>
            ))}
          </div>
          <div className="khas-modal-actions">
            <button className="khas-btn khas-btn-primary" onClick={() => { onGoTab('riwayat'); onClose() }}>
              Lihat Riwayat
            </button>
            <button className="khas-btn khas-btn-outline" onClick={onClose}>Tutup</button>
          </div>
        </div>
      </div>
    </div>
  )
}

/* ── DaftarTab ─────────────────────────────────────────────── */
function DaftarTab({ session, onSubmitSuccess, onToast, onConfirm, onGoTab }) {
  const [form,       setForm]       = useState(FORM0)
  const [successRec, setSuccessRec] = useState(null)
  const [loading,    setLoading]    = useState(false)
  const formRef = useRef()

  const set   = (f, v) => setForm(p => ({ ...p, [f]: v }))
  const reset = () => setForm(FORM0)

  const handleTelp = e => set('telp', e.target.value.replace(/[^0-9+\-\s]/g, ''))

  const handleSubmit = e => {
    e.preventDefault()
    if (!formRef.current.checkValidity()) { formRef.current.reportValidity(); return }
    onConfirm({
      title:   'Konfirmasi Pengajuan',
      message: 'Apakah Anda yakin ingin mengirim pengajuan ini?',
      yes:     'Ya, kirim pengajuan',
      onYes:   submitForm,
    })
  }

  const submitForm = async () => {
    setLoading(true)
    try {
      const formData = new FormData()
      formData.append('nama',            form.nama.trim())
      formData.append('provinsi',        form.provinsi)
      formData.append('kota',            form.kota.trim())
      formData.append('alamat',          form.alamat || '')
      formData.append('basis',           form.basis  || '')
      formData.append('tipe',            form.tipe)
      formData.append('pic',             form.pic.trim())
      formData.append('telp',            form.telp.trim())
      formData.append('email',           form.email  || '')
      formData.append('instansi',        form.instansi || '')
      formData.append('alamat_instansi', form.alamat_instansi || '')
      formData.append('catatan',         form.catatan || '')
      formData.append('kriteria', JSON.stringify([0,1,2,3,4,5].map(i => !!form['k'+i])))

      const result = await pengajuanApi.create(formData)
      reset()
      setSuccessRec({ ...result.pengajuan, tipe: form.tipe })
      onSubmitSuccess()
    } catch (err) {
      onToast(err.message || 'Gagal mengirim pengajuan')
    }
    setLoading(false)
  }

  const REQ = <span style={{ color:'var(--khas-red)' }}>*</span>

  return (
    <div>
      {successRec && <SuccessModal rec={successRec} onClose={() => setSuccessRec(null)} onGoTab={onGoTab} />}

      <form ref={formRef} onSubmit={handleSubmit}>

        {/* 1. Identitas Kawasan */}
        <fieldset className="khas-fieldset">
          <legend className="khas-legend">1 · Identitas Kawasan</legend>

          <label className="khas-fld">
            <span className="khas-lt">Nama kawasan kuliner {REQ}</span>
            <input className="khas-input" value={form.nama} required
              onChange={e => set('nama', e.target.value)}
              placeholder="cth. Foodcourt Taman Sehati" />
          </label>

          <div className="khas-grid2">
            <label className="khas-fld">
              <span className="khas-lt">Provinsi {REQ}</span>
              <select className="khas-input" value={form.provinsi} required
                onChange={e => { set('provinsi', e.target.value); set('kota', '') }}>
                <option value="">Pilih provinsi</option>
                {PROVINSI.map(p => <option key={p}>{p}</option>)}
              </select>
            </label>

            <label className="khas-fld">
              <span className="khas-lt">Kota / Kabupaten {REQ}</span>
              <input
                className="khas-input"
                value={form.kota}
                required
                onChange={e => set('kota', e.target.value)}
                placeholder="Ketik nama kota / kabupaten"
              />
            </label>
          </div>

          <label className="khas-fld">
            <span className="khas-lt">Alamat kawasan</span>
            <textarea className="khas-input" value={form.alamat}
              onChange={e => set('alamat', e.target.value)}
              placeholder="Alamat lengkap lokasi kawasan kuliner" />
          </label>

          <div className="khas-grid2">
            <label className="khas-fld">
              <span className="khas-lt">Basis / lokus kawasan {REQ}</span>
              <select className="khas-input" value={form.basis} required
                onChange={e => set('basis', e.target.value)}>
                <option value="">Pilih basis</option>
                {BASIS.map(b => <option key={b}>{b}</option>)}
              </select>
            </label>

            <label className="khas-fld">
              <span className="khas-lt">Tipe kawasan {REQ}</span>
              <select className="khas-input" value={form.tipe}
                onChange={e => set('tipe', e.target.value)}>
                {TIPE_KAWASAN.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
              </select>
              <span className="khas-hint">
                {TIPE_KAWASAN.find(t => t.value === form.tipe)?.deskripsi}
              </span>
            </label>
          </div>
        </fieldset>

        {/* 2. Pengelola & Kontak */}
        <fieldset className="khas-fieldset">
          <legend className="khas-legend">2 · Pengelola &amp; Kontak</legend>

          <div className="khas-grid2">
            <label className="khas-fld">
              <span className="khas-lt">Nama pengelola {REQ}</span>
              <input className="khas-input" value={form.pic} required
                onChange={e => set('pic', e.target.value)}
                placeholder="Nama lengkap pengelola" />
            </label>

            <label className="khas-fld">
              <span className="khas-lt">No. WhatsApp / telepon {REQ}</span>
              <input className="khas-input" value={form.telp} required
                onChange={handleTelp}
                placeholder="08xx" inputMode="tel"
                pattern="[0-9+\-\s]+" title="Hanya angka" />
              <span className="khas-hint">Hanya angka — huruf tidak diizinkan.</span>
            </label>
          </div>

          <div className="khas-grid2">
            <label className="khas-fld">
              <span className="khas-lt">Email</span>
              <input className="khas-input" type="email" value={form.email}
                onChange={e => set('email', e.target.value)}
                placeholder="nama@email.com" />
            </label>

            <label className="khas-fld">
              <span className="khas-lt">Instansi / pengelola</span>
              <input className="khas-input" value={form.instansi}
                onChange={e => set('instansi', e.target.value)}
                placeholder="cth. DKM Masjid, Universitas" />
            </label>
          </div>

          <label className="khas-fld">
            <span className="khas-lt">Alamat instansi</span>
            <textarea className="khas-input" value={form.alamat_instansi}
              onChange={e => set('alamat_instansi', e.target.value)}
              placeholder="Alamat lengkap kantor instansi" />
          </label>
        </fieldset>

        {/* 3. Checklist Kriteria */}
        <fieldset className="khas-fieldset">
          <legend className="khas-legend">3 · Checklist 6 Kriteria Zona KHAS</legend>
          <p className="khas-hint" style={{ marginTop:-2 }}>Centang kriteria yang sudah terpenuhi.</p>
          {KRITERIA.map((c, i) => (
            <label key={i} className={'khas-crit-check' + (form['k'+i] ? ' on' : '')}>
              <input type="checkbox" checked={form['k'+i]}
                onChange={e => set('k'+i, e.target.checked)} />
              <div>
                <div className="khas-cb">{c.t}</div>
                <div className="khas-cd">{c.d}</div>
              </div>
            </label>
          ))}
        </fieldset>

        {/* 4. Catatan */}
        <fieldset className="khas-fieldset">
          <legend className="khas-legend">4 · Catatan Tambahan</legend>
          <label className="khas-fld">
            <span className="khas-lt">Keterangan tambahan</span>
            <textarea className="khas-input" value={form.catatan}
              onChange={e => set('catatan', e.target.value)}
              placeholder="cth. butuh fasilitasi sertifikasi halal" />
          </label>
        </fieldset>

        <div style={{ display:'flex', gap:10 }}>
          <button type="submit" className="khas-btn khas-btn-primary"
            style={{ fontSize:15, padding:'13px 26px' }} disabled={loading}>
            {loading ? 'Mengirim...' : 'Kirim Pengajuan'}
          </button>
          <button type="button" className="khas-btn khas-btn-outline"
            onClick={reset} disabled={loading}>
            Reset
          </button>
        </div>
      </form>
    </div>
  )
}

export default DaftarTab